const A = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAqCAYAAABP7FAaAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEcSURBVFiFxZZREsMgCEShk3vVniztyfRm269OE0ULBO1+xhleZAEhChKADGCPiqcFAkBeBdzxVVoBTDhrCTQficuBFj9vTuBORKn6XDyxtMDaR7Ofnpuu60Ui0Uezn0SGm3Z8nKeBjx/Fp3yQVnMRRQFjhwLOc7WnuCGv8NEN3QZn6uIwggsPgiRDIIuKBNT46FWbEeh99KrN3mRgWyNQ9OMFiWndJwLb4YE/+ZgnAsVe38S+Gav9c1mFmV/G2LIMmdH+nArqTqsXqCm62AddAVUNfus2eP9xHlM4R2FcRHNW06tp/Uh8T0dQMQizKY5l702do4cFaIJ29GTmcjFGX0IRubfAKzeNb49aS9qjAqalwAoass1bPQ3x8Q2zLRmUd1J0ggAAAABJRU5ErkJggg==";
export {
  A as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/assets/lightning.png.js
// module id = 1143
// module chunks = 41